<template>
  <div id='legend-root'>
    <div id='legend-header'>
      <h2>How to read this visualization</h2>
      <div class='description'>
          Each visualization is of one individual's interactions with <a href='https://www.sfmoma.org/read/send-me-sfmoma/' target='_new'>Send Me SFMOMA</a> over the course of a week.  Each tree represents a day, and each flower or leaf represents a text they sent and an artwork they got back.
      </div>
    </div>

    <div id="legend" class='container'>

      <div class='card item2'>
        <h3>1. What mood were they in?</h3>
        <!-- <div class='description'>
          Were they happy?  Were they sad?  Were they curious?
        </div> -->

        <div id='type' class='container'>
          <!-- positive -->
          <div style='grid-column: 1 / 2; grid-row: 1 / 2'>
            <div class='header'>Positive:</div>
            <span style="font-size: 0.9em;">send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">love </span>
            <span style="font-size: 0.6em;">03:43PM</span>
          </div>
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 1 / 2'>→</div>
          <img src='@/images/flower.png' width='50' style='grid-column: 3 / 4; grid-row: 1 / 2' />
          <!-- neutral -->
          <div style='grid-column: 1 / 2; grid-row: 2 / 3'>
            <div class='header'>Neutral:</div>
            <span style="font-size: 0.9em;">send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">abstract </span>
            <span style="font-size: 0.6em;">09:11PM</span>
          </div>
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 2 / 3'>→</div>
          <img src='@/images/leaf.png' width='50' style='grid-column: 3 / 4; grid-row: 2 / 3'/>
          <!-- negative -->
          <div style='grid-column: 1 / 2; grid-row: 3 / 4'>
            <div class='header'>Negative:</div>
            <span style="font-size: 0.9em;">send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">death </span>
            <span style="font-size: 0.6em;">08:07PM</span>
          </div>
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 3 / 4'>→</div>
          <img src='@/images/empty.png' width='50' style='grid-column: 3 / 4; grid-row: 3 / 4'/>
        </div>
      </div>

      <div class='card item3'>
        <h3>2. What did they get back?</h3>
        <!-- <div class='description'>
          Was the artwork vibrant in color?  Monochromatic?  Light?  Dark?
        </div> -->

        <div id='color' class='container'>
          <!-- 1 -->
          <img src='@/images/color1-2.jpg' width='100%' style='grid-column: 1 / 2; grid-row: 1 / 2' />
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 1 / 2'>→</div>
          <img src='@/images/color1-1.png' width='50' style='grid-column: 3 / 4; grid-row: 1 / 2' />
          <!-- 2 -->
          <img src='@/images/color2-2.jpg' width='100%' style='grid-column: 1 / 2; grid-row: 2 / 3' />
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 2 / 3'>→</div>
          <img src='@/images/color2-1.png' width='50' style='grid-column: 3 / 4; grid-row: 2 / 3' />
          <!-- 3 -->
          <img src='@/images/color3-2.jpg' width='100%' style='grid-column: 1 / 2; grid-row: 3 / 4' />
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 3 / 4'>→</div>
          <img src='@/images/color3-1.png' width='50' style='grid-column: 3 / 4; grid-row: 3 / 4' />
        </div>
      </div>

      <div class='card item4'>
        <h3>3. How did it effect them?</h3>
        <div class='description' style='text-align:center'>
          <img src='@/images/hover.png' width='280' />
        </div>

        <div id='hover' class='container'>
          <!-- bakery -->
          <div class='header' style='grid-column: 1 / 2; grid-row: 1 / 2'>
            <span style="font-size: 0.9em;">1. send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">bakery </span>
            <span style="font-size: 0.6em;">08:27PM</span>
          </div>
          <img src='@/images/bakery.jpg' width='100%' style='grid-column: 1 / 2; grid-row: 2 / 3' />
          <!-- arrow -->
          <div class='arrow' style='grid-column: 2 / 3; grid-row: 2 / 3'>→</div>
          <!-- smile -->
          <div class='header'  style='grid-column: 3 / 4; grid-row: 1 / 2'>
            <span style="font-size: 0.9em;">2. send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">smile </span>
            <span style="font-size: 0.6em;">08:27PM</span>
          </div>
          <img src='@/images/smile.jpg' width='100%' style='grid-column: 3 / 4; grid-row: 2 / 3' />
          <!-- arrow -->
          <div class='arrow' style='grid-column: 4 / 5; grid-row: 2 / 3'>→</div>
          <!-- tears -->
          <div class='header' style='grid-column: 5 / 6; grid-row: 1 / 2'>
            <span style="font-size: 0.9em;">3. send me </span>
            <span style="font-size: 0.9em; font-weight: 600;">tears </span>
            <span style="font-size: 0.6em;">08:27PM</span>
          </div>
          <img src='@/images/tears.jpg' width='100%' style='grid-column: 5 / 6; grid-row: 2 / 3' />
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'Legend',
  props: ['headerHeight', 'footerHeight'],

}
</script>

<style scoped>
#legend-root {
  margin-top: 40px;
}

#legend-header {
  border-top: 1px solid rgba(68,73,76,0.2);
  max-width: 900px;
  margin: auto;
}

#legend-header h2 {
  text-align: center;
}

.container {
  width: 100%;
  display: grid;
  align-items: center;
  grid-row-gap: 10px;
  line-height: 1;
}

#legend.container {
  grid-template-columns: 1.5fr 1.5fr 2fr;
  grid-column-gap: 10px;
  align-items: baseline;
  max-width: 900px;
  margin: auto;
}

/* grid items */
/* .item1 {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
} */

.item2 {
  grid-column: 1 / 2;
  /* grid-row: 2 / 3; */
}

.item3 {
  grid-column: 2 / 3;
  /* grid-row: 1 / 3; */
}

.item4 {
  grid-column: 3 / 4;
  /* grid-row: 1 / 3; */
}

/* content */
h3 {
  margin-top: 0;
  text-align: center;
}

.description {
  line-height: 1.6;
  margin: 10px 0;
}

#type.container, #color.container {
  grid-template-columns: 3fr 0.5fr 1fr ;
  grid-template-rows: auto auto auto;
}

#hover.container {
  grid-template-columns: 1fr 0.25fr 1fr 0.25fr 1fr;
  grid-template-rows: auto auto;
  grid-row-gap: 10px;
}

#type .header {
  /* font-weight: bold; */
  text-decoration: underline;
}

#hover .header {
  align-self: start;
}

.arrow {
  text-align: center;
}

/* for mobile portrait */
@media (min-width: 320px) and (max-width: 480px) {
  #legend.container {
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto auto;
  }

  /* grid items */
  .item1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .item2 {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }

  .item3 {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
  }

  .item4 {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
  }
}

/* for mobile landscape or ipad portrait */
@media (min-width: 481px) and (max-width: 768px) {
  #legend.container {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  /* grid items */
  .item1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .item2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }

  .item3 {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }

  .item4 {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Legend.vue